// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1EBMl","rootSuccess":"CompleteLink_rootSuccess__1rUxv","rootFailure":"CompleteLink_rootFailure__1y9G6","isDisabled":"CompleteLink_isDisabled__1KoBh"};